import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownload, faSearch, faFilter } from "@fortawesome/free-solid-svg-icons";
import TobNavBar from "../../../DashBaord/Top_navbar";
import ShowData from "../../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import { inventoryLogs } from "../../../../controllers/V1/products/productController";
import { getPage } from "../../../../controllers/common";
import ExportPopup from "./inventoryExport";
import { usePermissions } from "../../../../controllers/PermissionContext";
import { formatProjectDate } from "../../../../controllers/common";
import moment from "moment";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("productInventory");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isInventoryExportShow, setInventoryExportShow] = useState(false);
  const handleInventoryExportDrawer = () => setInventoryExportShow(!isInventoryExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'user_name'?{user_name : filter?.search }:null),
          ...(filter?.filter_by === 'pos_number'?{pos_number : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'mobile'?{mobile : filter?.search }:null),
          ...(filter?.filter_by === 'bind_person_name'?{bind_person_name : filter?.search }:null),
          ...(filter?.filter_by === 'product_name'?{product_name : filter?.search }:null), 
          ...(filter?.filter_by === 'narration'?{narration : { $regex: filter?.search, $options: "i" } }:null),
          ...((filter?.to && filter?.from) && { 
            createdAt : { 
              $gte : moment(filter?.from).startOf('days').format('YYYY-MM-DD HH:mm:ss'), 
              $lte : moment(filter?.to).endOf('days').format('YYYY-MM-DD HH:mm:ss')
            }
          })
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? parseInt(LIMIT) : 10,
      };
      const listData = await inventoryLogs(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT));
        } else {
          setListData([]);
          setTotalPages(getPage(1));
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error : ", error);
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    document.title = `Crown King || Inventory Logs`;
  }, [currentPage, filter, LIMIT]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={`Inventory Logs`} />
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                    />
                  </Tabs>
                </div>
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div">
                    <ShowData setLimit={setLimit} limit={LIMIT} />
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.export === 'Y') && (
                    <div className="inventory_filter_div px-4" onClick={handleInventoryExportDrawer} >
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link to={false} className="filter_btn_invontry_rating_review" > Export </Link>
                    </div>
                  )}
                </div>
              </div>
            </Box>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Name</th>
                              <th>POS Details</th>
                              <th>Bind With</th>
                              <th>Product name</th>
                              <th>Old Qty.</th>
                              <th>Qty.</th>
                              <th>New Qty.</th>
                              <th>Created on</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{SKIP + index + 1}</td>
                                    <td className="admin_user_list_date">
                                      <span>{`${items?.user_name}`}</span><br/>
                                      <span>{`${items?.mobile}`}</span>
                                    </td>

                                    {items?.pos_number ? (
                                      <td>{items.pos_number}</td>
                                    ) : (
                                      <td> N/A </td>
                                    )}

                                    <td>{items?.bind_person_name}</td>
                                    <td>{items?.product_name}</td>
                                    <td>{items?.before || 0}</td>
                                    <td>{items?.qty || 0}</td>
                                    <td>{items?.after || 0}</td>
                                    
                                    <td className="admin_user_list_date">
                                      {formatProjectDate(items?.createdAt)}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? (
                              <SkeltonList row={5} col={8} />
                            ) : (
                              <tr>
                                <td colspan="11" className="img-center">
                                  No data found !
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <ExportPopup
        popUpOpen={isInventoryExportShow}
        togglePopUp={handleInventoryExportDrawer}
      />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'var(--brand-red)', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='user_name' selected={filter?.filter_by ==='user_name'?true:false}>Name</option>
                  <option value='pos_number' selected={filter?.filter_by ==='pos_number'?true:false}>POS Number</option>
                  <option value='mobile' selected={filter?.filter_by ==='mobile'?true:false}>Mobile</option>
                  <option value='bind_person_name' selected={filter?.filter_by ==='bind_person_name'?true:false}>Bind with name</option>
                  <option value='product_name' selected={filter?.filter_by ==='product_name'?true:false}>Product Name</option>
                  <option value='narration' selected={filter?.filter_by ==='narration'?true:false}>narration</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
